import { LoadingIcon } from '@assets/icons';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { Box, Container, Stack, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { LogsRow } from './LogsRow';
import { SaveLogsToFileButton } from './SaveLogsToFileButton';
import { LogType } from './types';

const renderLogRow = (_index: number, log: LogType) => <LogsRow log={log} />;

export const LogsScreen = ({
  downloadFileName,
  header,
  loading,
  logs,
}: {
  downloadFileName?: string;
  header?: ReactNode;
  loading?: boolean;
  logs: LogType[];
}) => {
  const { palette } = useTheme();

  if (!loading && logs.length === 0) {
    return (
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: 6,
          ml: 0,
        }}
        disableGutters
      >
        <Stack
          flex={1}
          sx={{
            backgroundColor: palette.background.paper,
            p: 3,
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
          }}
        >
          <Typography mt={4}>No logs found</Typography>
          {/* TODO: Add button for support contact */}
        </Stack>
      </Container>
    );
  }

  return (
    <Container
      maxWidth="lg"
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        pt: 6,
        ml: 0,
        minHeight: 0,
      }}
      disableGutters
    >
      <Group
        alignItems="flex-end"
        justifyContent={header ? 'space-between' : 'flex-end'}
        sx={{ visibility: loading ? 'hidden' : 'visible' }}
      >
        {header}
        <SaveLogsToFileButton logs={logs} name={downloadFileName} />
      </Group>

      {loading && (
        <Stack alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
          <LoadingIcon size={16} />
        </Stack>
      )}
      {!loading && logs.length > 0 && (
        <Box flex={1} sx={{ backgroundColor: palette.background.paper, p: 3, minHeight: 0 }}>
          <Virtuoso data={logs} itemContent={renderLogRow} style={{ height: '100%' }} />
        </Box>
      )}
    </Container>
  );
};
